export default __webpack_public_path__ + "static/media/020-firecracker.72116686.svg";